import { Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface LaborCostSourceTagProps {
  laborCostSource: 'estimated'
}

const LaborCostSourceTag = ({ laborCostSource }: LaborCostSourceTagProps) => {
  const getLaborCostSourceLabel = (): string => {
    switch (laborCostSource) {
      case 'estimated':
        return i18n.t('project_management.tags.labor_cost_source.estimated')
    }
  }

  return (
    <Tag inline capitalize type={'malibu'}>
      {getLaborCostSourceLabel()}
    </Tag>
  )
}

export default LaborCostSourceTag
